import ROUTES from '../routes';
import Margins from '../hoc/margins/margins';
import MarginList from '../hoc/margins/list';
import MarginDetails from '../hoc/margins/margin-details';

const MarginsRoutes = {
  path: ROUTES.MARGINS,
  element: <Margins />,
  children: [
    {
      path: ROUTES.MARGINS_CURRENCY,
      element: <MarginList />,
      children: [
        {
          path: ROUTES.MARGIN_INFO,
          element: <MarginDetails />,
        },
      ],
    },
  ],
};

export default MarginsRoutes;
